import { Button } from '@mui/material';
import React from 'react';
import RichTextEditor from '../../../components/global/RichTextEditor';
import { useForm } from 'react-hook-form';

type Props = {
  terms: string;
  setTerms: React.Dispatch<React.SetStateAction<string | null>>;
  saveTerms: () => void;
};

function Terms({ terms, setTerms, saveTerms }: Props) {
  const { handleSubmit, control } = useForm<{
    terms: string;
  }>({
    defaultValues: {
      terms,
    },
  });

  return (
    <div className="">
      <form
        onSubmit={handleSubmit((data) => {
          setTerms(data.terms);
          saveTerms();
        })}
      >
        <h2 className="text-2xl font-bold mb-2">Regulamin sklepu</h2>
        {terms.length === 0 && (
          <p className="text-red-500 mb-5">
            UWAGA! Brak regulaminu sklepu. Proszę o dodanie treści.
          </p>
        )}
        <RichTextEditor name="terms" control={control} defaultValue={terms} />
        <Button
          variant="outlined"
          color="success"
          style={{ padding: '5px 10px', marginTop: '10px' }}
          type="submit"
        >
          Zapisz regulamin
        </Button>
      </form>
    </div>
  );
}

export default Terms;
